import { padding } from 'polished'

export const __textarea = props => ({
	background: 'transparent',
	border: 'none',
	boxSizing: 'border-box',
	cursor: 'inherit',
	font: 'inherit',
	height: '100%',
	lineHeight: 'inherit',
	outline: 'none',
	padding: 0,
	resize: 'none',
	width: '100%',
	extend: {
		condition: props.readOnly,
		style: {
			color: props.theme.colors.darkGrey4,
		},
	},
})

export const __shadowTextarea = () => ({
	border: 'none',
	boxSizing: 'border-box',
	font: 'inherit',
	height: 'auto',
	lineHeight: 'inherit',
	// Overflow also needed to here to remove the extra row
	// added to textareas in Firefox.
	overflow: 'hidden',
	position: 'absolute',
	padding: 0,
	resize: 'none',
	// Visibility needed to hide the extra text area on ipads
	visibility: 'hidden',
	whiteSpace: 'pre-wrap',
	width: '100%',
})

export const __textareaWrapper = props => {
	const { theme, hasError } = props
	const primary = theme.primary(theme)

	return {
		...padding('8px', '0'),
		width: '100%',
		borderBottom: hasError
			? `1px solid ${primary.errorColor}`
			: `1px solid ${primary.borderColor}`,
		lineHeight: '24px',
	}
}

export const __heightSyncronizer = props => ({
	height: `${props.height}px`,
	position: 'relative',
	width: '100%',
})
